import {Component, OnInit, inject, signal} from '@angular/core';
import {Card} from 'primeng/card';
import {TaAppStore} from '../../../state/clcta-store';
import {SessionService, VersionInfo} from '../../../services/session.service';

interface ReleaseInfo {
  version: string;
  date: string;
  current: boolean;
}

@Component({
  selector: 'clc-releasenotes-page',
  imports: [Card],
  templateUrl: './clc-releasenotes-page.html',
  styleUrl: './clc-releasenotes-page.scss'
})
export class ClcReleasenotesPage implements OnInit {

  private store = inject(TaAppStore);
  private sessionService = inject(SessionService);

  currentVersion: VersionInfo = this.sessionService.getVersionInfo();

  versions: ReleaseInfo[] = [
    {
      version: '1.5',
      date: 'November 2026',
      current: true,
    },
    {
      version: '1.4',
      date: 'October 2026',
      current: false,
    },
    {
      version: '1.3',
      date: 'September 2026',
      current: false,
    },
    {
      version: '1.2',
      date: 'August 2026',
      current: false,
    },
    {
      version: '1.1',
      date: 'August 2026',
      current: false,
    },
    {
      version: '1.0',
      date: 'July 2026',
      current: false,
    }
  ];

  selectedVersion = signal<ReleaseInfo>(this.versions.find(v => v.current)!);

  ngOnInit() {
    this.store.updateBreadCrumbData({
      title: `Release Notes ${this.currentVersion.majorMinor} build (${this.currentVersion.build})`,
      titleIcon: 'fa-regular fa-notes fa-lg'
    });
  }

  selectVersion(version: ReleaseInfo): void {
    this.selectedVersion.set(version);
  }

  versionLabel(version: ReleaseInfo): string {
    return `Version ${version.version}${version.current ? ' (Current)' : ''}`;
  }
}
